import React from "react";

import { Skeleton } from "@replo/design-system/components/skeleton/Skeleton";
import twMerge from "@replo/design-system/utils/twMerge";

import FullPageLoadingAnimation from "./FullPageLoadingAnimation";

type PagePreviewProps = {
  cachedPageHtml: string | undefined;
  isLoadingPage: boolean;
  isInteractive: boolean;
  isScrollable: boolean;
};

const PagePreview: React.FC<PagePreviewProps> = ({
  cachedPageHtml,
  isLoadingPage,
  isInteractive,
  isScrollable,
}) => {
  // NOTE (Gabe 2025-07-23): This means the cachedContent is loading.
  if (cachedPageHtml === undefined) {
    return null;
  }
  return (
    <>
      {!cachedPageHtml &&
        isLoadingPage &&
        (isInteractive ? (
          <FullPageLoadingAnimation className="absolute" />
        ) : (
          <Skeleton
            className="h-full w-full rounded absolute "
            speed={2}
            backgroundColor="#f1f5f9"
            foregroundColor="#e2e8f0"
          />
        ))}
      {/* This is a static iframe that is used to display the cached version of the page */}
      {cachedPageHtml && (isLoadingPage || !isInteractive) && (
        <iframe
          srcDoc={cachedPageHtml}
          className={twMerge(
            "h-full w-full absolute",
            isInteractive && "opacity-60",
          )}
          scrolling={isScrollable ? "auto" : "no"}
          // NOTE (Ben 2025-07-17): This is needed to prevent the iframe from being included in window
          // history and messing up navigation.
          sandbox="allow-same-origin"
        />
      )}
    </>
  );
};

export default PagePreview;
